"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var Table_1 = __importDefault(require("@mui/material/Table"));
var TableBody_1 = __importDefault(require("@mui/material/TableBody"));
var TableCell_1 = __importDefault(require("@mui/material/TableCell"));
var TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
var TableHead_1 = __importDefault(require("@mui/material/TableHead"));
var TableRow_1 = __importDefault(require("@mui/material/TableRow"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var muiTableSx = {
    "& .MuiTable-root": {
        marginTop: "0px"
    },
    "& .MuiTableCell-head": {
        backgroundColor: "var(--secondary-color-tinted)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .MuiTableCell-body": {
        color: "var(--info-color)",
    },
    "& .MuiTableRow-root:last-child": {
        borderBottom: "unset",
    }
};
var LatestAccounts = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)([]), latestAccounts = _a[0], setLatestAccounts = _a[1];
    var getLatestAccounts = function () {
        ApiManager_1.default.getLatestAccountsForPartner().then(function (accounts) {
            console.log(accounts);
            setLatestAccounts(accounts);
        });
    };
    (0, react_1.useEffect)(function () {
        getLatestAccounts();
    }, []);
    return (react_1.default.createElement(TableContainer_1.default, { component: Paper_1.default, sx: { width: "150%" } },
        react_1.default.createElement(Table_1.default, { "aria-label": "simple table", sx: muiTableSx },
            react_1.default.createElement(TableHead_1.default, null,
                react_1.default.createElement(TableRow_1.default, null,
                    react_1.default.createElement(TableCell_1.default, { align: "left", sx: { width: "65%" } }, t("Name")),
                    react_1.default.createElement(TableCell_1.default, { align: "center", sx: { width: "10%" } }, t("ID")),
                    react_1.default.createElement(TableCell_1.default, { align: "left", sx: { width: "25%" } }, t("Created Date")))),
            react_1.default.createElement(TableBody_1.default, null, latestAccounts.map(function (account) { return (react_1.default.createElement(TableRow_1.default, { key: account.id, sx: { "&:last-child td, &:last-child th": { border: 0 } }, "data-cy": "customerAccount" },
                react_1.default.createElement(TableCell_1.default, { align: "left", sx: { fontFamily: "Geomanist-Bold" } }, account.name),
                react_1.default.createElement(TableCell_1.default, { align: "center" }, account.id),
                react_1.default.createElement(TableCell_1.default, { align: "left" }, account.created_at.split("T")[0]))); })))));
};
exports.default = LatestAccounts;
